// extracted by mini-css-extract-plugin
export var active = "_bh-b";
export var activeIndicator = "_bh-6";
export var animate = "_bh-a";
export var disabled = "_bh-c";
export var flat = "_bh-1";
export var fullWidth = "_bh-3";
export var lg = "_bh-9";
export var md = "_bh-8";
export var redoButtonTabGroup = "_bh-0";
export var sm = "_bh-7";
export var tabButton = "_bh-4";
export var tabButtonsContainer = "_bh-2";
export var xs = "_bh-5";